import React from 'react';

import { StepProps } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import { InvitationAcceptanceValues } from './Controller';

import NotFound from '../Checking/components/NotFound';
import { trackClick } from '../features/track';
import Footer from '../Shared/components/Footer';
import { urlBuilder } from '../Shared/urlBuilder';

export interface Props extends StepProps<InvitationAcceptanceValues> {
  isOnlyAccount: boolean;
}

const Success: React.FC<React.PropsWithChildren<Props>> = ({ flowState, isOnlyAccount }) => {
  const { invitation } = flowState.values;

  if (!invitation) {
    return <NotFound />;
  }

  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box mb="8">
          <Icon name="CheckmarkCircle" size="large" color="icon.accent.teal" />
        </Box>
        <Heading as="h1" variant="primary">
          Your Joint Checking account has been created
        </Heading>
        {isOnlyAccount ? (
          <Box mb="9" mt="8">
            <Text as="p">
              Keep an eye out for your Betterment Visa&reg; Debit Card, which should arrive in 6-8 business days.
            </Text>
          </Box>
        ) : (
          <Box mb="9" mt="8">
            <Text as="p">
              Your Betterment Visa&reg; Debit Card is now connected to both of your Checking accounts. It's currently
              set to spend from your first account, but you can always switch accounts in your Checking settings.
            </Text>
          </Box>
        )}
        <CenteredWorkflowLayout.Actions>
          <SambaAutoLink
            variant="solidPrimary"
            onClick={() => trackClick({ name: 'ViewNewJCAccountSecondary', flow: 'OpenJointCheckingSecondary' })}
            to={urlBuilder.getAppCheckingSummary.absolute({ accountId: invitation.accountId })}
          >
            View your account
          </SambaAutoLink>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};
export default Success;
